module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTYgOTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGlkPSJJY29uc19CYWNrX0xUUiIgb3ZlcmZsb3c9ImhpZGRlbiI+PHBhdGggZD0iTTggNDMgMzYuNiAxOSAzNi42IDMzQzgwLjUgMzMuNCA4OCA3OCA4OCA3OCA4OCA3OCA3MS43IDU0LjMgMzYuNiA1NEwzNi42IDY3IDggNDNaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card2-11.svg
// module id = YGxP
// module chunks = 1